module.exports = __webpack_public_path__ + "img/lavista.3b96875c.svg";